import { render } from "./VitalSigns.vue?vue&type=template&id=7bd15ca2&scoped=true"
import script from "./VitalSigns.vue?vue&type=script&lang=js"
export * from "./VitalSigns.vue?vue&type=script&lang=js"

import "./VitalSigns.vue?vue&type=style&index=0&id=7bd15ca2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd15ca2"]])

export default __exports__